import { Info } from 'lucide-react'
import { Button } from '@app/ui'
import { useDeployRefresh } from '@/hooks/useDeployRefresh'

/**
 * Full-width prompt at the top of the app when `/version.json` reports a
 * newer frontend than this tab loaded. Refresh is a full reload so the new
 * assets replace the in-memory SPA.
 */
export function DeployRefreshBanner() {
  const updateAvailable = useDeployRefresh()
  if (!updateAvailable) return null

  return (
    <div
      role="status"
      className="flex shrink-0 flex-wrap items-center justify-center gap-2 border-b border-ds-brand/30 bg-ds-brand-subtle px-3 py-2 text-ds-sm text-ds-text sm:gap-3"
    >
      <Info className="size-4 shrink-0 text-ds-brand" aria-hidden />
      <span>A new version is available.</span>
      <Button
        size="sm"
        variant="primary"
        onClick={() => {
          window.location.reload()
        }}
      >
        Refresh
      </Button>
    </div>
  )
}
